<hr>
<div class="col-12 text-center">
  <small class="text-white fw-bold">
    <a class="text-decoration-none text-white mx-2" routerLink="/terms" target="_blank"
      id="link-terms-and-conditions">Terms and Conditions</a> |
    <a class="text-decoration-none text-white mx-2" routerLink="/privacy" target="_blank"
      id="link-privacy-policy">Privacy Policy</a> |
    <a class="text-decoration-none text-white mx-2" routerLink="/contact" target="_blank"
      id="link-contact-us">Contact Us</a>
    <br>
    <p class="mt-2 mb-4 text-white">© {{ currentYear }} {{ brandResources.companyTitle! }}. All rights reserved.
    </p>
    <div class="pb-4">
      <span style="background-color: rgba(0, 0, 0, 0.11);">*Scores and rankings shown above are examples
        only.</span>
    </div>
  </small>
</div>